import React, { useState } from "react";
import Button from "../../../../reusable-components/buttons/Button";
import TableWrapper from "../../../../reusable-components/table/TableWrapper";
import { linkTextPrimary } from "../../../../theme/lightTheme";

import { GENDER_CONFIG_URL } from "../../../../api/api_routing_urls";
import axios from "../../../../api/axios";
import DeleteModal from "../../../../reusable-components/modals/DeleteModal";
import showToast from "../../../../utilities/notification/NotificationModal";
import { linkTextDanger } from "../../../../theme/lightTheme";

export default function GenderList({
  genderList,
  getGenderList,
  setEditGenderDetails,
  setShowAddForm,
}) {
  const onClickEdit = (gender) => {
    setEditGenderDetails(gender);
    setShowAddForm(true);
  };

  const [showDelete, setShowDelete] = useState(false);
  const [genderDeleteId, setGenderDeleteId] = useState(null);

  const onClickDelete = async () => {
    // console.log("Received ID to delete: ", genderDeleteId);
    try {
      let response = "";
      if (genderDeleteId) {
        response = await axios.post(`${GENDER_CONFIG_URL}/delete`, {
          gender_id: genderDeleteId,
        });
        setShowDelete(false);
      }

      if (response.status === 200) {
        showToast("Gender details has been deleted successfully.", "success");
        getGenderList();
      } else {
        showToast("Gender details deletion failed.", "error");
      }
    } catch (error) {
      console.log("Delete Module Error", error);
    } finally {
      setGenderDeleteId(null);
    }
  };

  return (
    <TableWrapper>
      <thead className="bg-white text-sm">
        <tr>
          <th
            scope="col"
            className="px-6 py-3 text-left font-medium text-gray-900 uppercase tracking-wider"
          >
            Sl No.
          </th>
          <th
            scope="col"
            className="px-6 py-3 text-left font-medium text-gray-900 uppercase tracking-wider"
          >
            Gender Name
          </th>
          <th
            scope="col"
            className="pl-6 pr-9 py-3 text-right font-medium text-gray-900 uppercase tracking-wider"
          >
            Actions
          </th>
        </tr>
      </thead>
      <tbody className="bg-white divide-y divide-gray-100 text-gray-600">
        {genderList?.length > 0 &&
          genderList?.map((gender, index) => (
            <tr key={index}>
              <td className="px-6 py-4 whitespace-nowrap text-sm">
                {index+1}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm">
                {gender.gender_name}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm">
                <div className="flex justify-end">
                  <Button
                    onClick={() => onClickEdit(gender)}
                    aria-label="Edit Gender Details"
                    className={linkTextPrimary}
                  >
                    Edit
                  </Button>
                  <Button
                    onClick={() => {
                      setGenderDeleteId(gender?.gender_id || null);
                      setShowDelete(true);
                    }}
                    aria-label="Delete Gender Details"
                    className={linkTextDanger}
                  >
                    Delete
                  </Button>
                </div>
              </td>
            </tr>
          ))}
      </tbody>

      <>
        <DeleteModal
          open={showDelete}
          setOpen={setShowDelete}
          message={"This entry will be deleted. Are you sure?"}
          onDelete={onClickDelete}
        />
      </>
    </TableWrapper>
  );
}
